import * as random from 'random';
import * as shuffle from 'shuffle-array';
import { ApiService } from '../api.service';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { LabelService } from '../label.service';
import { MatchingGameService } from './matching-game.service';
import { Subscription } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'app-matching-game',
  templateUrl: './matching-game.component.html',
  styleUrls: ['./matching-game.component.scss'],
})
export class MatchingGameComponent implements OnInit, OnDestroy {
  private subs: Subscription = new Subscription();

  @Input() lang = 'tc';
  @Input() csvpath = '';
  @Input() labelpath = '';
  @Input() imgpath = '/assets/img';

  matchDataListSource: any[] = [];
  matchingList: any[] = [];
  seedList: any[] = [];
  nameList: any[] = [];
  photoList: any[] = [];

  userSelectedItem = { seed: null, name: null, photo: null };
  userSelectedItemType: string[] = [];
  userSelectedItemStatus = { seed: null, name: null, photo: null };
  userSelectedItemLock = { seed: null, name: null, photo: null };

  selectedItemsCorrect: any[] = [];

  start = false;
  showResult = false;

  label;

  ansMask = false;

  uuid = '';

  constructor(private labelService: LabelService, private matchingGameService: MatchingGameService, private apiService: ApiService) {}

  ngOnInit() {
    this.subs.add(this.labelService.getLabel(this.labelpath).subscribe(res => (this.label = res)));
    this.subs.add(
      this.matchingGameService.getMatchingList(this.csvpath).subscribe(res => {
        this.matchDataListSource = res.data;
        // this.seedList = shuffle(res, { copy: true });
        // this.nameList = shuffle(res, { copy: true });
        // this.photoList = shuffle(res, { copy: true });
        this.randomMatchData();
      }),
    );
  }

  private randomMatchData() {
    this.matchingList = [];
    this.seedList = [];
    this.nameList = [];
    this.photoList = [];

    do {
      const rand = random.int(0, this.matchDataListSource.length - 1);
      const item = this.matchDataListSource[rand];
      if (this.matchingList.findIndex(x => x.id === item.id) === -1) {
        this.matchingList.push(item);
      }
    } while (this.matchingList.length < 6);

    this.seedList = shuffle(this.matchingList, { copy: true });
    this.nameList = shuffle(this.matchingList, { copy: true });
    this.photoList = shuffle(this.matchingList, { copy: true });
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  gameStart() {
    this.start = true;
    this.uuid = uuidv4();

    this.apiService
      .gameStart({
        user_token_id: this.uuid,
        game_type: 'match',
        lang_id: this.lang,
      })
      .subscribe();
  }

  gameReset() {
    this.start = false;
    this.userSelectedItem = { seed: null, name: null, photo: null };
    this.userSelectedItemType = [];
    this.userSelectedItemStatus = { seed: null, name: null, photo: null };
    this.userSelectedItemLock = { seed: null, name: null, photo: null };
    this.selectedItemsCorrect = [];
    this.showResult = false;
    this.randomMatchData();
  }

  selectItem(item, type: 'seed' | 'name' | 'photo') {
    // if (this.selectedItemsCorrect.findIndex((c) => c.id === item.id) === -1) {
    //   this.userSelectedItem[type] = !this.userSelectedItem[type] || this.userSelectedItem[type].id !== item.id ? item : null;

    //   const typeIdx = this.userSelectedItemType.findIndex((t) => t === type);
    //   if (typeIdx === -1) {
    //     this.userSelectedItemType.push(type);
    //   } else {
    //     this.userSelectedItemType.splice(typeIdx, 1);
    //     if (this.userSelectedItem[type]) {
    //       this.userSelectedItemType.push(type);
    //     }
    //   }
    //   this.selectedItemCheck();
    // }

    if (this.userSelectedItemStatus[type] === null && this.userSelectedItemLock[type] === null) {
      this.userSelectedItem[type] = item;
      this.selectedItemCheckingCore();
    }
  }

  // old version
  private selectedItemCheck() {
    this.userSelectedItemStatus = { seed: null, name: null, photo: null };

    let checker = null;
    for (const t of this.userSelectedItemType) {
      if (!checker && this.userSelectedItem[t]) {
        checker = this.userSelectedItem[t];
        this.userSelectedItemStatus[t] = true;
      } else {
        this.userSelectedItemStatus[t] = checker.id === this.userSelectedItem[t].id ? true : false;
      }
    }

    if (this.userSelectedItemStatus.seed && this.userSelectedItemStatus.name && this.userSelectedItemStatus.photo) {
      this.selectedItemsCorrect.push(this.userSelectedItem.seed);

      this.userSelectedItem = { seed: null, name: null, photo: null };
      this.userSelectedItemType = [];
      this.userSelectedItemStatus = { seed: null, name: null, photo: null };
    }
  }

  // new version
  private selectedItemCheckingCore() {
    if (this.userSelectedItem.seed && this.userSelectedItem.name && this.userSelectedItem.photo) {
      this.ansMask = true;
      //
      // console.log(this.userSelectedItem);
      //
      // 1. 三綠剔 (ABC)
      // 2. 雙綠剔 單紅交叉 (AB 或 BC 或 AC)
      // 3. 三紅叉 (沒雙綠便全紅)
      //
      let reset = true;

      if (
        this.userSelectedItem.seed.id === this.userSelectedItem.name.id &&
        this.userSelectedItem.seed.id === this.userSelectedItem.photo.id &&
        this.userSelectedItem.name.id === this.userSelectedItem.photo.id
      ) {
        this.userSelectedItemStatus = { seed: true, name: true, photo: true };
        reset = false;
        this.selectedItemsCorrect.push(this.userSelectedItem.seed);
        this.userSelectedItemStatus = { seed: null, name: null, photo: null };
        this.userSelectedItem = { seed: null, name: null, photo: null };
        this.userSelectedItemLock = { seed: null, name: null, photo: null };
        this.ansMask = false;
      } else if (this.userSelectedItem.seed.id === this.userSelectedItem.name.id && this.userSelectedItem.seed.id !== this.userSelectedItem.photo.id) {
        this.userSelectedItemStatus = { seed: true, name: true, photo: false };
        this.userSelectedItemLock.seed = this.userSelectedItem.seed;
        this.userSelectedItemLock.name = this.userSelectedItem.name;
      } else if (this.userSelectedItem.seed.id !== this.userSelectedItem.name.id && this.userSelectedItem.seed.id === this.userSelectedItem.photo.id) {
        this.userSelectedItemStatus = { seed: true, name: false, photo: true };
        this.userSelectedItemLock.seed = this.userSelectedItem.seed;
        this.userSelectedItemLock.photo = this.userSelectedItem.photo;
      } else if (this.userSelectedItem.name.id === this.userSelectedItem.photo.id && this.userSelectedItem.seed.id !== this.userSelectedItem.name.id) {
        this.userSelectedItemStatus = { seed: false, name: true, photo: true };
        this.userSelectedItemLock.name = this.userSelectedItem.name;
        this.userSelectedItemLock.photo = this.userSelectedItem.photo;
      } else {
        this.userSelectedItemStatus = { seed: false, name: false, photo: false };
      }

      if (reset) {
        setTimeout(() => {
          // console.log(`with after 3s`);
          this.userSelectedItemStatus = { seed: null, name: null, photo: null };
          this.userSelectedItem = { seed: null, name: null, photo: null };
          this.ansMask = false;

          for (const k of Object.keys(this.userSelectedItemLock)) {
            this.userSelectedItem[k] = this.userSelectedItemLock[k];
          }
        }, 2000);
      }
    }
  }

  checkIsCorrectMatch(item) {
    return this.selectedItemsCorrect.findIndex(c => c.id === item.id) !== -1;
  }

  matchingSubmit() {
    if (this.selectedItemsCorrect.length === this.seedList.length) {
      this.showResult = true;

      this.apiService
        .gameResultAdd({
          user_token_id: this.uuid,
          game_type: 'match',
          correct_question_cnt: 6,
          total_question_cnt: 6,
          total_score: 100,
          lang_id: this.lang,
        })
        .subscribe();
    }
  }
}
